import { DocContent, DocNode } from '../models/types';

export const mockDocIndex: DocNode[] = [
  {
    id: 'platform-docs',
    name: 'Platform',
    path: 'platform/docs',
    type: 'folder',
    category: 'Platform',
    children: [
      {
        id: 'platform-architecture',
        name: 'ARCHITECTURE.md',
        path: 'platform/docs/ARCHITECTURE.md',
        type: 'file',
        category: 'Platform'
      }
    ]
  },
  {
    id: 'product-docs',
    name: 'Product',
    path: 'docs',
    type: 'folder',
    category: 'Product',
    children: [
      {
        id: 'technical-guide',
        name: 'architecture-guide.md',
        path: 'docs/documentation/developers/architecture-guide.md',
        type: 'file',
        category: 'Product'
      }
    ]
  }
];

export const mockDocContent: DocContent = {
  path: 'platform/docs/ARCHITECTURE.md',
  category: 'Platform',
  title: 'ARCHITECTURE.md',
  content: '# Placeholder\n\nContent could not be loaded from the source. This fallback keeps navigation working for now.'
};
